import _ from "lodash";
import { singleton } from "@/shared/decorators/singleton";

@singleton
class Cache {
  private cache = new Map();

  set<T>(key: string, value: T) {
    return this.cache.set(key, _.cloneDeep(value));
  }

  get<T>(key: string): T {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return _.cloneDeep(this.cache.get(key));
  }

  remove(key: string) {
    return this.cache.delete(key);
  }
}

export const cache = new Cache();
